import React from "react";

import { FaLinkedin, FaGithub, FaEnvelope,FaTwitter } from "react-icons/fa";
import "./Homepage.css"
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from 'react-router-dom';
import BikashSingh from './images/BikashSingh.jpg';

function HomePage() {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (

<div class="bg-gradient-to-r from-blue-900 via-blue-700 to-blue-500 auto-h-screen ">


      <main className="container mx-auto mt-10 px-6">
  <div className="flex flex-col md:flex-row">
    <div className="md:w-1/2">
   <br></br><br></br>
   <motion.h1
              ref={ref}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-white"
            >
              <h1 className="text-blue-400 inline-block">Hi, I'm</h1> Bikash Singh
            </motion.h1>
      <motion.p
              ref={ref}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-blue-300 mt-4 text-outline md:text-justify font-mono font-bold text-lg lg:text-xl xl:text-2xl"
            >
              A versatile React frontend developer with expertise in crafting exceptional user interfaces and optimizing UX. I specialize in creating visually appealing and user-friendly web applications, paying close attention to detail. My passion lies in delivering seamless experiences, ensuring the best possible user experience.
            </motion.p>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="mt-8 flex flex-col md:flex-row"
      >
        <motion.a
          whileHover={{ scale: 1.05 }}
          className="bg-blue-500 hover:bg-blue-600 font-semibold text-white py-2 px-4 rounded-md md:mr-4 mb-4 md:mb-0"
          href="https://github.com/BikashSingh-GitHub?tab=repositories"
        >
          View My Work
        </motion.a>
      </motion.div>
    </div>
    
    <div className="w-full md:w-1/2 mt-6 md:mt-0 flex justify-center items-center">


<div className="artwork"><img src={BikashSingh} alt="Bikash" /></div>

    </div>
    
  </div>
  
</main>
<div class="flex flex-col items-center justify-center from-blue-500 via-blue-800 to-blue-900  py-8">
  <h2 class="text-2xl  text-white font-bold mb-6">Technology Stacks :</h2>
  <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-9 gap-6">
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://previews.123rf.com/images/outchill/outchill1801/outchill180108924/94474306-html-blue-text-round-stamp-with-zig-zag-border-and-vintage-texture.jpg"
          alt="HTML"
          className="w-16 h-16 border-4 border-gray-900 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- HTML</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://www.pngkit.com/png/detail/222-2229478_css-logo-html-css-design-and-build-web.png"
          alt="CSS"
          className="w-16 h-16 border-4 border-gray-900 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- CSS</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTPWkcGUeqCz6D44gkaPi_-Hk11VokCEIQW0g&usqp=CAU"
          alt="ReactJS"
          className="w-16 h-16 border-4 border-blue-200 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- JavaScript</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://bourhaouta.gallerycdn.vsassets.io/extensions/bourhaouta/tailwindshades/0.0.5/1592520164095/Microsoft.VisualStudio.Services.Icons.Default"
          alt="Tailwind"
          className="w-16 h-16 border-4 border-blue-200 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- Tailwind</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://cdn.iconscout.com/icon/free/png-256/free-react-1-282599.png?f=webp"
          alt="ReactJS"
          className="w-16 h-16 border-4 border-blue-200 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- React JS</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://ih1.redbubble.net/image.2299119385.0038/st,small,507x507-pad,600x600,f8f8f8.jpg"
          alt="ReactJS"
          className="w-16 h-16 border-4 border-gray-900 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- Redux</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8ZvXAFs02fg19pmpZiXpnFAi_1zaUqVQRjrcGNWMV40TvD5n_jBPRX1CFtw43Y_onExE&usqp=CAU"
          alt="ReactJS"
          className="w-16 h-16 border-4 border-gray-900 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- Node JS</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://t3.ftcdn.net/jpg/05/30/78/66/360_F_530786694_IxcIx1r9Z1FsDLZ7xv8D0X4QlIUIDRzS.jpg"
          alt="ReactJS"
          className="w-16 h-16 border-4 border-blue-200 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- Adobe XD</span>
      </motion.li>
      <motion.li
        whileHover={{ scale: 1.1 }}
        className="flex items-center"
      >
        <img
          src="https://i.pinimg.com/originals/18/f1/72/18f1727873924ba58fde1f739d11b77b.png"
          alt="ReactJS"
          className="w-16 h-16 border-4 border-blue-200 rounded-full"
        />
        <span className="ml-2 text-blue-300 font-bold">- Figma</span>
      </motion.li>
    </ul>
</div>







</div>

);
}

export default HomePage;